<template >
  <div>
    <div style="background-color: #fff; border-radius: 3px; padding-top: 10px;">
      <van-list class="goods-list" v-for="goods in orderProductData" :key="goods.id">
        <van-row class="goods-item" style="display: flex;">
          <van-col span="8" style="text-align: center; margin: auto;">
            <img class="thumbnail" v-lazy="goods.productThumbnailUrl">
          </van-col>
          <van-col span="15" style="margin-left: 5px;">
            <div class="title">{{goods.productTitle}}</div>
            <div class="bar-code">{{generateCustomizeString('barCode')}} {{goods.productId}}</div>
            <div class="expiry-date">{{generateCustomizeString('bestBefore')}} {{goods.bestBefore}}</div>
            <div class="price"><span>{{goods.unitPrice}} </span><span class="number"> x{{goods.amount}}</span></div>
          </van-col>
        </van-row>
      </van-list>
    </div>
    <van-row style="margin-top: 5px; background: #fff; border-radius: 3px;">
      <van-col span="24">
        <van-cell-group>
          <van-cell :title="generateCustomizeString('goodsValue')" :value="'NZD $' + orderDetailData.goods_fee / 100" />
          <!-- <van-cell :title="generateCustomizeString('shippingFee')" :value="'NZD $' + orderDetailData.express_fee / 100" /> -->
          <van-cell :title="generateCustomizeString('totalFee')" :value="'NZD $' + orderDetailData.fee / 100" />
        </van-cell-group>
      </van-col>
    </van-row>
  </div>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import { Row, Col, Uploader, Icon, Button, Cell, CellGroup, Tag, List } from 'vant'

export default {
  name: 'GoodsList',
  components: {
    [Uploader.name]: Uploader,
    [Icon.name]: Icon,
    [Row.name]: Row,
    [Col.name]: Col,
    [Button.name]: Button,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Tag.name]: Tag,
    [List.name]: List
  },
  data() {
    return {
      active: 0,
      activeTab: 0,
      imgLink: 'https://img.nzmai.com.cn/000robbme4_1537254820869.jpg'
    }
  },
  props: {
    orderDetailData: {
      type: Object,
      default: () => ({})
    },
    orderProductData: {
      type: Array,
      default: () => ([])
    }
  },
  methods: {
    generateCustomizeString
    // onClickLeft() {
    //   this.$router.replace({ name: 'Orders' })
    // }
  },
  created: function() {
    // Add barcode scan listener and pass the callback function
    // this.RegisterWxJsApi()
  }
}
</script>

<style lang="less" scoped>
  .goods-list {
    margin: 0 1rem 0 1rem;
    padding-bottom: 8px;
    height: auto;
  }
  .goods-item {
    height: auto;
    padding: 5px 0;
  }
  .title {
    font-size: 0.8rem;
    line-height: 1rem;
  }
  .thumbnail {
    background: #f5f5f5;
    width: 5rem;
    height: 5rem;
  }
  .price {
    color: #FFA800;
    font-weight: 700;
    line-height: 1rem;
    font-size: 0.8rem;
  }
  .expiry-date {
    font-size: .7rem;
    line-height: 1rem;
  }
  .bar-code {
    font-size: .7rem;
    line-height: 1rem;
  }
</style>
